/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Auth_Refresh_RaceInputs */

const vi_error_auth_refresh_race = /** @type {(inputs: Error_Auth_Refresh_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên đăng nhập vừa được gia hạn ở tab khác. Tải lại trang để tiếp tục.`)
};

/**

* @param {Error_Auth_Refresh_RaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_auth_refresh_race = /** @type {((inputs?: Error_Auth_Refresh_RaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Auth_Refresh_RaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_auth_refresh_race(inputs)
});